export default __webpack_public_path__ + "static/media/photo-icon.e87b0f71.svg";